/* eslint-disable react/prop-types */
import React from "react";
import {
  Box,
  List,
  ListItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import siteData from "../../../../_data";

// Function to render each link
const SectionLinkItem = ({ href, label, footer1, customfontsize }) => {
  return (
    <ListItem sx={{ p: 0, m: 0 }}>
      <Typography
        variant="inherit"
        component={Link}
        to={href}
        sx={{
          p: 0,
          mb: 1,
          display: "block",
          position: "relative",
          overflow: "hidden",
          width: "100%",
          color: footer1.body,
          fontSize: `${customfontsize}px`,
          "&:before": {
            content: '""',
            position: "absolute",
            bottom: 0,
            backgroundColor: footer1.body,
            left: 0,
            width: 0,
            height: "2px",
            transform: "translateX(-100%)",
            transition: "transform 0.3s ease",
          },
          "&:hover:before": {
            width: "100%",
            transform: "translateX(0)",
          },
        }}
      >
        {label}
      </Typography>
    </ListItem>
  );
};

function SectionLinks({ customfontsize }) {
  const {
    palette: { footer1 },
  } = useTheme();
  const matchesMdOrLess = useMediaQuery((theme) =>
    theme.breakpoints.down("md")
  );

  const { navSection } = siteData;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "start",
        justifyContent: matchesMdOrLess ? "start" : "space-around",
        p: 0,
        m: 0,
        width: "100%",
      }}
    >
      {navSection.map((section) => (
        <Box
          key={section.title}
          sx={{
            width: "50%",
            display: "flex",
            alignItems: "start",
            justifyContent: "start",
          }}
        >
          <Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                textTransform: "uppercase",
                mb: 1,
                color: footer1.heading,
                fontSize: `${1.5 * customfontsize}px`,
              }}
            >
              {section.title}
            </Typography>
            <List sx={{ p: 0, m: 0 }}>
              {section.links.map((link) => (
                <SectionLinkItem
                  key={link.label}
                  href={link.href}
                  label={link.label}
                  footer1={footer1}
                  customfontsize={customfontsize}
                />
              ))}
            </List>
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export default SectionLinks;
